import React, { useEffect, useRef, useState } from "react"
import {
  Table,
  Input,
  Select,
  Modal,
  Form,
  Radio,
  Card,
  Typography,
  Image,
  Row,
  Col,
  Pagination,
  Spin,
  Skeleton,
  message,
  Empty,
  Descriptions,
  Drawer,
  InputNumber,
  Badge,
  Divider,
} from "antd"
import {
  FireFilled,
  FrownOutlined,
  ShareAltOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons"
import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectCountry from "src/components/Dropdown/SelectCountry"
import CheckPackage from "./components/CheckPackage"
import PackageService from "src/services/PackageService"
import PackageDetailModal from "src/pages/LEADER/SubscriberManagement/Modal/ModalDetail"
import Button from "../../../components/MyButton/Button"
import PublicService from "src/services/PublicService"
import STORAGE, { getStorage, getStorageCookie } from "src/lib/storage"
import { set } from "lodash"
import ModalAuth from "src/components/Layouts/component/ModalAuth"
import { useLocation, useNavigate } from "react-router-dom"
import { simType } from "src/constants/constants"
import { useDispatch, useSelector } from "react-redux"
import {
  addToCart,
  updateCartItemQuantity,
  removeFromCart,
  clearCart,
} from "src/redux/cartSlice"
import CartDrawer from "./components/CartDrawer"
import OrderB2BService from "src/services/OrderB2BService"
import ROUTER from "src/router"
import ModalDeposite from "src/pages/LEADER/BuySimPackage/Modal/ModalDeposite"
import BuyPackageAnonymous from "src/pages/ANONYMOUS/BuyPackage"
import dayjs from "dayjs"

const { Search } = Input
const { Option } = Select
const { Title, Text } = Typography
const phoneRegex = /^0\d{9}$/
const serviceTypeMap = {
  1: "Local",
  2: "Roaming",
}

const BuyPackge = props => {
  const [searchValue, setSearchValue] = useState("")
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 6,
  })
  const [keyword, setKeyword] = useState("")
  const [selectedPackage, setSelectedPackage] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isPhoneModalVisible, setIsPhoneModalVisible] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState("")
  const [filter, setFilter] = useState({})
  const [loading, setLoading] = useState(true)
  const [modalLoginOpen, setModalLoginOpen] = useState(false)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [bulkQuantity, setBulkQuantity] = useState(1) // Số lượng mặc định là 1
  const [arrearsMoney, setArrearsMoney] = useState(0)
  const [depositVisible, setDepositVisible] = useState(false)

  const role = localStorage.getItem(STORAGE.ROLES)
  const isLogin = getStorageCookie(STORAGE.TOKEN)

  const cartItems = useSelector(state => state.cart.items);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const location = useLocation()
  const selectedPackageNav = location.state || {}

  const level = localStorage.getItem(STORAGE.LEVEL)
  useEffect(() => {
    if (selectedPackageNav?.name) {
      setKeyword(selectedPackageNav.name)
    }
  }, [selectedPackageNav])
  const showDrawer = () => {
    setDrawerVisible(true)
  }

  const onClose = () => {
    setDrawerVisible(false)
  }

  const fetchListPackage = async keyword => {
    setLoading(true)
    let response = {}
    if (role === "LEADER" && isLogin) {
      response = await OrderB2BService.getPackageListLeader({
        page: pagination.current,
        per_page: pagination.pageSize,
        filter: {
          ...filter,
          status: "1",
        },
        keyword: keyword,
      })
    } else {
      response = await PublicService.getListPackageSell({
        page: pagination.current,
        per_page: pagination.pageSize,
        filter: {
          ...filter,
          status: "1",
        },
        keyword: keyword,
      })
    }

    const success = response?.success
    if (success) {
      const packages = success.data || []
      const total = success.total || 0
      const current = success.current_page || 1
      const perPage = success.per_page || 50

      setData(packages)
      setPagination({
        ...pagination,
        total,
      })
      setLoading(false)
    } else {
      console.error("Failed to fetch packages:", response?.error)
    }
  }

  useEffect(() => {
    if (!isLogin) {
      fetchListPackage(keyword)
    }
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined && !isLogin) {
        fetchListPackage(keyword)
      }
    }
  }, [keyword, filter])

  const handleCardClick = packageItem => {
    if (!isLogin) {
      message.error("Vui lòng đăng nhập")
      // return navigate(ROUTER.DANG_NHAP, { state: { from: "order", record } })
      setModalLoginOpen(true)
      return
    }
    console.log('packageItem : hihihi', packageItem)
    // setIsPhoneModalVisible(true)
    // handleBuyPackage(packageItem)
    handleAddToCart(packageItem)
    // setSelectedPackage(packageItem)
  }

  const handleTableChange = (page, pageSize) => {
    setPagination(prev => ({
      ...prev,
      current: page,
      pageSize: Number(pageSize), // ép kiểu rõ ràng
    }))
  }

  const handleSharePackage = packageItem => {
    const shareLink = `${window.location.origin}/share-package/${packageItem.ID}`
    navigator.clipboard
      .writeText(shareLink)
      .then(() => {
        message.success("Đã sao chép liên kết chia sẻ gói cước!")
      })
      .catch(err => {
        console.error("Failed to copy share link:", err)
        message.error("Không thể sao chép liên kết chia sẻ gói cước.")
      })
  }
  const handleBuyPackage = async () => {
    const commissionPercent =
      Number(localStorage.getItem(STORAGE.COMMISSION_PERCENT)) || 0
    console.log(cartItems, "cartItems in cart drawer")
    const maxPackageType = Math.max(
      ...cartItems.map(item => Number(item.package?.package_type) || 0),
    )
    const deliveryDate = dayjs().add(maxPackageType, "day").format("YYYY/MM/DD")
    const result = cartItems?.map(item => {
      return {
        // ...item.package,
        sim_quantity: item.quantity,
        network_id: item.package.network_id || null,
        type_sim: item.package.type_sim || null,
        sim_type: item.package.sim_type || null,
        scope: item.package.scope || null,
        sim_unit_price: item.package.sim_unit_price || 0,
        package_id: item.package.package_id || null,
        supplier_id: item.package.supplier_id || null,
        mode: Number(item.package.mode),
        commission: item.package.commission,
        master_price: item.package.master_price || null
      }
    })
    console.log(result, "result")
    const totalAmount = cartItems.reduce((total, item) => {
      const price = parseFloat(item.package?.sim_unit_price)
      const quantity = item.quantity || 0
      return total + price * quantity
    }, 0)
    if (role === "LEADER" && isLogin) {
      setLoading(true)
      try {
        const payload = {
          total_amount: totalAmount,
          // total_discount: totalAmount - totalAmount * (commissionPercent / 100),
          sim: result,
          expected_delivery_date: deliveryDate,
          sim_type: result[0].type_sim === "usim" ? 1 : 2,
        }
        if (level !== "0" && isLogin) {
          await OrderB2BService.createOrderAgency(payload)
        } else {
          await OrderB2BService.createOrderB2B(payload)
        }
        message.success("Tạo đơn hàng thành công")
        setSelectedPackage(null)
        setBulkQuantity(1) // Reset số lượng về 1
        dispatch(clearCart()) // Xóa giỏ hàng sau khi mua thành công
        navigate(ROUTER.AGENT_SIM_PACKAGE_SERVICE)
      } catch (err) {
        if (err.response?.status === 400) {
          message.error(err?.response?.data?.message || "Lỗi không xác định")
        }
        const errorMessage =
          err?.response?.data?.message?.message ||
          err?.response?.data?.message ||
          "Lỗi không xác định từ máy chủ"
        if (err?.response?.data?.message?.amount_missing) {
          setArrearsMoney(err?.response?.data?.message?.amount_missing)
          setDepositVisible(true)
        }
        message.error(errorMessage)
      } finally {
        setLoading(false)
      }
    }
    // Đóng modal và reset các giá trị
    setIsPhoneModalVisible(false)
    // setSelectedPackage(null)
    // setBulkQuantity(1) // Reset số lượng về 1
    // dispatch(clearCart()) // Xóa giỏ hàng sau khi mua thành công
    onClose()
  }
  const handleRemoveItem = package_id => {
    dispatch(removeFromCart(package_id))
    message.success("Đã xóa gói cước khỏi giỏ hàng!")
  }

  const handleAddToCart = packageItem => {
    if (!packageItem || !packageItem.name) {
      message.error("Vui lòng chọn gói cước hợp lệ")
      return
    }

    dispatch(addToCart({ packageItem: packageItem, quantity: bulkQuantity }))
    message.success("Đã thêm gói vào giỏ hàng!")
  }

  const handleQuantityChange = (package_id, newQuantity) => {
    if (newQuantity <= 0) {
      message.error("Số lượng phải lớn hơn 0!")
      return
    }

    dispatch(updateCartItemQuantity({ package_id, newQuantity }))
    // message.success("Đã cập nhật số lượng!")
  }
  const handleCloseModal = () => {
    setDepositVisible(false)
    setArrearsMoney(0)
  }

  const renderPackages = () => {
    return data.map(packageItem => (
      <Col xs={24} md={12} xl={8} key={packageItem.ID}>
        <Card
          bordered
          hoverable
          style={{
            border: "1px solid #99CCFF",
            borderRadius: 16,
            marginBottom: 16,
            textAlign: "center",
            height: 300,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: 0,
            transition: "box-shadow 0.3s ease, transform 0.3s ease",
          }}
          bodyStyle={{ padding: 24 }}
          // onClick={() => handleCardClick(packageItem)}
          onMouseEnter={e => {
            e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,255,0.3)"
            e.currentTarget.style.transform = "translateY(-6px)"
          }}
          onMouseLeave={e => {
            e.currentTarget.style.boxShadow = ""
            e.currentTarget.style.transform = "translateY(0)"
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: 16,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <FireFilled style={{ color: "#f5222d" }} />
              {packageItem.name}
            </div>
            {/*<div style={{ color: "#999" }}>Chi tiết</div>*/}
            <ShareAltOutlined
              style={{ fontSize: 18, color: "#1890ff", cursor: "pointer" }}
              onClick={e => {
                e.stopPropagation()
                message.success("Đã copy link chia sẻ gói cước")
                // handleSharePackage(packageItem)
              }}
              title="Chia sẻ gói cước"
            />
          </div>

          <div style={{ borderTop: "1px solid #eee", marginBottom: 16 }}></div>

          {/* DATA */}
          <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
            {packageItem.data_quantity}GB/
            {packageItem.daily_total === "Daily" ? "Ngày" : "Tháng"}
          </div>

          {/* Ghi chú */}
          <div
            style={{
              fontSize: 13,
              color: "#555",
              marginBottom: 24,
              minHeight: "40px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div>
              Nhà mạng: <strong>{packageItem?.network?.name}</strong>
            </div>
            <div>
              {serviceTypeMap[packageItem?.service_type] || "Unknown"} /
              {simType.find(opt => opt.key === packageItem?.sim_type)?.value ||
                "Unknown"}
            </div>
            <br />
            {packageItem.note}
            {/*Miễn phí gọi nội mạng iTel & VinaPhone (áp dụng cuộc gọi dưới 10 phút, tối đa 1000 phút/tháng)*/}
          </div>
          {/* Giá và nút */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap", // Thêm dòng này
              gap: 8, // Và một chút khoảng cách
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 600 }}>
              {new Intl.NumberFormat().format(
                packageItem.price_setting || packageItem.price_sell,
              )}
              /<span style={{ fontSize: 18 }}>{packageItem.date}</span>
            </div>
            <Button
              btnType="primary1"
              onClick={e => {
                e.stopPropagation()
                // setSelectedPackage(packageItem)
                handleCardClick(packageItem)
              }}
            >
              {isLogin ? "Thêm vào giỏ hàng" : "Mua ngay"}
            </Button>
          </div>
        </Card>
      </Col>
    ))
  }

  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 30,
            marginBottom: 16,
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <h3
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#005F90",
              margin: 0,
            }}
          >
            MUA SIM GÓI CƯỚC
          </h3>
          {isLogin && (
            <Badge
              style={{ marginRight: 16 }}
              count={cartItems.length}
              offset={[10, 0]}
            >
              <Button
                btnType="primary1"
                icon={<ShoppingCartOutlined />}
                onClick={showDrawer}
              />
            </Badge>
          )}
        </div>
        {/* <div>
          <CheckPackage setFilter={setFilter} setKeyword={setKeyword} />
        </div> */}
        {/* <div style={{ margin: "10px 0", fontWeight: "bold", color: "#007BFF" }}>
          Tổng số gói cước: {pagination.total}
        </div> */}
        {isLogin ? (
          <BuyPackageAnonymous setOpenCart={setDrawerVisible} filter={filter} />
        ) : (
          <>
            {" "}
            <Row gutter={[16, 16]}>
              {renderPackages()}
              <div style={{ marginTop: 20, marginBottom: 20 }}>
                <Pagination
                  style={{ display: "flex", justifyContent: "flex-end" }}
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  onChange={handleTableChange}
                  showSizeChanger
                  pageSizeOptions={["6", "12", "18", "24"]}
                />
              </div>
            </Row>
          </>
        )}
      </div>
      {drawerVisible && (
        <CartDrawer
          drawerVisible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          cartItems={cartItems}
          handleQuantityChange={handleQuantityChange}
          handleBuyPackage={handleBuyPackage}
          handleRemoveItem={handleRemoveItem}
        />
      )}
      {depositVisible && (
        <ModalDeposite
          depositVisible={depositVisible}
          depositAmount={arrearsMoney}
          handleCancel={handleCloseModal}
          onSuccess={() => {
            // clear
            setDepositVisible(false)
            setArrearsMoney(0)
            handleBuyPackage()
          }}
        />
      )}

      {modalLoginOpen && (
        <ModalAuth
          visible={modalLoginOpen}
          onClose={() => setModalLoginOpen(false)}
          // record={productRecord}
          selectedPackage={selectedPackage}
        />
      )}
    </>
  )
}
export default BuyPackge
